module.exports = __webpack_public_path__ + "static/img/10.d20ae08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/10.jpg
// module id = 1PqX
// module chunks = 16